class ZigZagMenu {
  constructor({
    // Default options.
    panelEl = '.zig-zag-panel',
    showEl = '[data-action="zig-zag-show"]',
    closeEl = '[data-action="zig-zag-close"]',
    backdropEl = '.zig-zag-panel__backdrop',
  } = {}) {
    this.panelEl = document.querySelector(panelEl);
    this.showEl = document.querySelector(showEl);
    this.closeEl = document.querySelector(closeEl);
    this.backdropEl = document.querySelector(backdropEl);
  }

  show() {
    this.panelEl.setAttribute('aria-hidden', false);
    document.body.classList.add('zig-zag-panel--expanded');
  }

  close() {
    this.panelEl.setAttribute('aria-hidden', true);
    document.body.classList.remove('zig-zag-panel--expanded');
  }

  toggle() {
    if (this.panelEl.getAttribute('aria-hidden') === 'true') {
      this.show();
    } else {
      this.close();
    }
  }

  registerEvents() {
    if (this.showEl) this.showEl.addEventListener('click', () => { this.show(); });
    if (this.closeEl) this.closeEl.addEventListener('click', () => { this.close(); });
    if (this.backdropEl) this.backdropEl.addEventListener('click', () => { this.close(); });

    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape' && this.panelEl.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });
  }

  mount() {
    if (this.panelEl) {
      this.registerEvents();
    }
  }
}

function init() {
  new ZigZagMenu().mount();
}

export default {
  init,
};
